import { render } from "./sell.vue?vue&type=template&id=f3210888&scoped=true"
import script from "./sell.vue?vue&type=script&lang=js"
export * from "./sell.vue?vue&type=script&lang=js"

import "./sell.vue?vue&type=style&index=0&id=f3210888&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3210888"]])

export default __exports__